module.exports = __webpack_public_path__ + "media/images/ioscor-logo-16029c3f3e7fca0601e2913038f5213e.jpg";